import { flow } from 'lodash';
import { makeNullSafeDomainGetter, userPaymentTransactionDomainSelector, userPaymentTransactionsDomainSelector } from './common';
import { NetworkStatus } from 'apollo-client';

export const userPaymentTransactionDataSelector = makeNullSafeDomainGetter(userPaymentTransactionDomainSelector, 'userPaymentTransaction');
export const isUserPaymentTransactionLoadingSelector = flow(userPaymentTransactionDomainSelector, ({ networkStatus, data }) => !data && networkStatus === NetworkStatus.setVariables);

export const userPaymentTransactionsDataSelector = makeNullSafeDomainGetter(userPaymentTransactionsDomainSelector, 'userPaymentTransactions');
export const isUserPaymentTransactionsLoadingSelector = flow(userPaymentTransactionsDomainSelector, ({ networkStatus, data }) => !data && networkStatus === NetworkStatus.setVariables);
